/*eslint complexity: ["error", 26]*/
import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { CreateUpdateContractDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import {
  ContractStatusEnum,
  ContractStatusObj,
} from '../../../common/pokCore/validation/enums';
import { SelectContractToUpdate } from '../../containers/ContractsView/SelectContractToUpdate';

interface ContractTitleProps {
  id?: string;
  contract?: CreateUpdateContractDto;
  tv?: boolean;
  readyToUpdate?: boolean;
}

const ContractTitle: React.FC<ContractTitleProps> = ({
  contract,
  id,
  tv,
  readyToUpdate,
}) => {
  const { t, tk } = useTranslation('projectLng');

  return (
    <>
      <Card.Title className="pb-3 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          {id ? (
            <span
              style={
                contract?.active === false
                  ? { textDecoration: 'line-through' }
                  : {}
              }
            >
              {t(tk.contract.contract)}
              {contract?.number && (
                <>
                  : <b>{contract.number}</b>,
                </>
              )}{' '}
              {t(tk.common.sysNumberLowerCase)}{' '}
              {`${contract?.systemNumber || '-'}`}
            </span>
          ) : (
            <>{t(tk.contract.contractNew)}</>
          )}
          {contract?.status ? (
            <span
              style={
                contract?.active === false
                  ? { textDecoration: 'line-through' }
                  : {}
              }
            >
              &nbsp;[
              <b>{t(ContractStatusObj[contract?.status]).toUpperCase()}</b>]
            </span>
          ) : null}
          {(contract?.tv || tv) && (
            <OverlayTrigger overlay={<Tooltip>{t(tk.contract.tv)}</Tooltip>}>
              <Icon.DisplayFill size={20} className="ms-2 icon-blue" />
            </OverlayTrigger>
          )}
        </div>
        {id && contract && readyToUpdate && (
          <SelectContractToUpdate contractId={id} contract={contract} />
        )}
      </Card.Title>
      {contract?.status === ContractStatusEnum.Unsigned ? (
        <Card.Subtitle className="pt-3">
          {t(tk.contract.rejectionContractReason)}: {contract?.reasonUnsigning}
        </Card.Subtitle>
      ) : null}
      {contract?.status === ContractStatusEnum.Sent && contract?.sentByHand ? (
        <Card.Subtitle className="pt-3">
          {t(tk.contract.sentOutOfSystem)}
        </Card.Subtitle>
      ) : null}
    </>
  );
};

export default ContractTitle;
